import actions from './actions.js'
import mutations from './mutations.js'
import getters from './getters.js'

const state = {
  numMerchants: 0,
  currentMerchant: null,
  merchants: [],
  merchantLoading: false,
  numCustomers: 0,
  customers: [],
  customerLoading: false,
  numMerchantAccounts: 0,
  merchantAccounts: [],
  merchantAccountLoading: false,
  numAccounts: 0,
  accounts: [],
  accountLoading: false,
  transactionReportURL: '',
  pageTitle: '',
  csvData: {}
}

export default {
  state: () => state,
  mutations,
  actions,
  getters
}
